var _context;
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import VueRouter from "vue-router";
import store from "../store";
import * as Pages from "./pages";
import * as Layouts from "@Client/@Modules/main/layouts";
import ProgressLoader from "@Shared/@Utils/progress-loader";
import { authGuards, runGuards } from "./guards";
import { checkApplications, allowIfPendingValidation, allowIfNoSession, loadCustomStyles, checkIfGlobalMaintenanceMode } from "./guards/before-enter";
import AuthApp from "@Client/@Modules/main/components/auth-app.vue";
import Vue from "vue";
import { getRouteMetaValue } from "@Shared/@Utils/utils";
import { defer } from "lodash";
import { SETTINGS_TABS } from "@Client/@Utils/enums";
import { APPLICATION_WIDGET_PAGE_E } from "@Client/@Types/application-widget/types";
const routes = [{
  path: "/login",
  component: Layouts.SimpleLayout,
  meta: {
    clearState: true,
    ignoreStyles: false
  },
  beforeEnter: runGuards(allowIfNoSession),
  children: [{
    path: "",
    component: Pages.LoginContainer,
    name: "login",
    props: route => {
      const redirectPath = route.query.state;
      const paramsToken = route.query.params;
      const detailsToken = route.query.t;
      return {
        redirectPath,
        paramsToken,
        detailsToken
      };
    }
  }]
}, {
  path: "/reset-password",
  component: Layouts.SimpleLayout,
  beforeEnter: runGuards(checkIfGlobalMaintenanceMode),
  children: [{
    path: "",
    component: Pages.ResetPasswordContainer,
    name: "reset-password"
  }]
}, {
  path: "/registration",
  component: Layouts.SimpleLayout,
  beforeEnter: runGuards(checkIfGlobalMaintenanceMode, allowIfNoSession, (to, from, next) => {
    const isVerifyPage = to.name === "registration-verify" || to.name === "registration-complete";
    const validRequiredParams = to.query.t || to.query.params;
    if (!isVerifyPage && !validRequiredParams) return next({
      name: "quick-application"
    });
    return true;
  }),
  children: [{
    path: "",
    component: Pages.RegistrationContainer,
    name: "registration"
  }, {
    path: "verify",
    component: Pages.RegistrationContainer,
    name: "registration-verify",
    props: {
      page: "verify"
    },
    beforeEnter: runGuards(allowIfPendingValidation)
  }, {
    path: "complete",
    component: Pages.RegistrationContainer,
    name: "registration-complete",
    props: {
      page: "complete"
    },
    beforeEnter: runGuards(allowIfPendingValidation)
  }]
}, {
  path: "/subdomain-interstitial",
  component: Layouts.SimpleLayout,
  meta: {
    requiresAuth: true,
    topProgress: true,
    ignoreStyles: true
  },
  children: [{
    path: "",
    component: AuthApp,
    children: [{
      path: "",
      name: "subdomain-interstitial",
      component: Pages.SubdomainInterstitialContainer,
      props: route => ({
        force: route.query.force === true || route.query.force === "true",
        startUrl: route.query.startUrl
      })
    }]
  }]
}, {
  path: "/unsubscribe",
  component: Layouts.SimpleLayout,
  meta: {
    requiresAuth: false,
    topProgress: true,
    clearState: true
  },
  beforeEnter: runGuards(checkIfGlobalMaintenanceMode, (to, from, next) => {
    next(!!to.query.params);
  }),
  children: [{
    path: "",
    name: "unsubscribe",
    component: Pages.MarketingUnsubscribe,
    props: route => {
      var _route$query;
      return {
        token: ((_route$query = route.query) == null ? void 0 : _route$query.params) || "",
        sidebar: route.query.sidebar && route.query.sidebar === "true"
      };
    }
  }]
}, {
  path: "/noa-portal",
  component: Layouts.SimpleLayout,
  meta: {
    topProgress: true,
    clearState: true,
    ignoreStyles: true
  },
  beforeEnter: runGuards(checkIfGlobalMaintenanceMode, (to, from, next) => {
    if (!to.query.authorization) return next("not-found");
    next();
  }),
  children: [{
    path: "",
    name: "noa-portal",
    component: Pages.NoaPortalContainer,
    props: route => ({
      token: route.query.authorization
    })
  }]
}, {
  path: "/guest-upload",
  component: Layouts.SimpleLayout,
  meta: {
    topProgress: true,
    clearState: true
  },
  beforeEnter: runGuards(checkIfGlobalMaintenanceMode, (to, from, next) => {
    next(!!to.query.token);
  }),
  children: [{
    path: "",
    name: "guest-upload",
    component: Pages.GuestUploadContainer,
    props: route => ({
      clientName: route.query.clientName,
      token: route.query.token,
      sidebar: route.query.sidebar && route.query.sidebar === "true"
    })
  }]
}, {
  path: "/guest-fill-out",
  component: Layouts.SimpleLayout,
  meta: {
    topProgress: true,
    clearState: true
  },
  beforeEnter: runGuards(checkIfGlobalMaintenanceMode, (to, from, next) => {
    next(!!to.query.token);
  }),
  children: [{
    path: "",
    name: "guest-fill-out",
    component: Pages.GuestFillOutContainer,
    props: route => ({
      clientName: route.query.clientName,
      token: route.query.token
    })
  }]
}, {
  path: "/guest-lender/:urlId",
  component: Layouts.LenderSidebarLayout,
  meta: {
    clearState: true,
    ignoreStyles: true
  },
  children: [{
    path: "",
    name: "guest-lender",
    component: Pages.GuestLender
  }]
}, {
  path: "/application",
  component: Layouts.SimpleLayout,
  meta: {
    requiresAuth: true,
    topProgress: true
  },
  beforeEnter: runGuards(checkIfGlobalMaintenanceMode),
  children: [{
    path: "",
    component: AuthApp,
    children: [{
      path: "",
      name: "application-page",
      component: Pages.ApplicationContainer,
      beforeEnter: runGuards(checkApplications),
      props: route => ({
        startUrl: route.query.startUrl
      })
    }]
  }]
}, {
  path: "/",
  component: Layouts.SidebarLayout,
  meta: {
    requiresAuth: true,
    topProgress: true
  },
  beforeEnter: runGuards(checkIfGlobalMaintenanceMode),
  children: [{
    path: "",
    component: AuthApp,
    children: [{
      path: "",
      name: "home",
      redirect: "dashboard"
    }, {
      path: "dashboard",
      name: "dashboard",
      component: Pages.DashboardContainer,
      beforeEnter: runGuards(checkApplications)
    }, {
      path: "documents",
      name: "documents",
      component: Pages.DocumentsContainer
    }, {
      path: "key-contacts",
      name: "key-contacts",
      component: Pages.KeyContactsContainer
    }, {
      path: "settings",
      name: "settings",
      component: Pages.SettingsContainer,
      props: true,
      children: _mapInstanceProperty(_context = SETTINGS_TABS()).call(_context, ({
        key
      }) => ({
        name: key,
        path: key,
        props: true,
        meta: {
          tab: key
        }
      }))
    }, {
      path: "support",
      name: "support",
      component: Pages.SupportContainer
    }]
  }]
}, {
  path: "/quick-application",
  redirect(route) {
    return {
      name: "welcome-page",
      query: route.query
    };
  }
}, {
  path: "/lead",
  component: Layouts.SimpleLayout,
  meta: {
    clearState: true
  },
  beforeEnter: runGuards(checkIfGlobalMaintenanceMode),
  children: [{
    path: "",
    name: "lead",
    component: Pages.WidgetWizardContainer,
    props: route => ({
      widgetType: "leads",
      sidebar: route.query.sidebar && route.query.sidebar === "true",
      locale: route.query.locale
    })
  }]
}, {
  path: "/lead-loan",
  component: Layouts.SimpleLayout,
  meta: {
    clearState: true
  },
  beforeEnter: runGuards(checkIfGlobalMaintenanceMode),
  children: [{
    path: "",
    name: "lead-loan",
    component: Pages.WidgetWizardContainer,
    props: route => ({
      widgetType: "lead-loan",
      widgetParams: {
        r: route.query.r,
        notify: route.query.notify && route.query.notify === "true"
      },
      sidebar: route.query.sidebar && route.query.sidebar === "true",
      locale: route.query.locale
    })
  }]
}, {
  path: "/bank-statements",
  component: Layouts.SimpleLayout,
  meta: {
    clearState: true
  },
  beforeEnter: runGuards(checkIfGlobalMaintenanceMode, (to, from, next) => {
    const hasToken = !!to.query.t;
    const hasRequiredParams = to.query.applicationId && to.query.clientUsername;
    next(hasToken || hasRequiredParams);
  }),
  children: [{
    path: "",
    name: "bank-statements",
    component: Pages.BankStatementsContainer,
    props: route => ({
      token: route.query.t,
      applicationId: route.query.applicationId,
      clientUsername: route.query.clientUsername,
      showSideBar: !route.query.sidebar || route.query.sidebar === "true"
    })
  }]
},
// This route should probably be inside the new app routes
{
  path: "/verify-email",
  component: Layouts.SimpleLayout,
  children: [{
    path: "",
    name: "verify-email",
    component: Pages.EmailVerificationContainer,
    props: route => ({
      token: route.query.t
    })
  }]
}, {
  path: "/application-widget",
  component: Layouts.ApplicationSidebarLayout,
  meta: {
    clearState: false
  },
  children: [{
    path: "welcome",
    component: Pages.WelcomeWidgetContainer,
    name: "welcome-page",
    beforeEnter: runGuards(allowIfNoSession),
    props: route => ({
      referrerId: route.query.r,
      locale: route.query.locale
    })
  }, {
    path: "",
    component: AuthApp,
    meta: {
      requiresAuth: true,
      routeRedirectName: "welcome-page"
    },
    props: () => ({
      routeRedirectName: "welcome-page"
    }),
    children: [{
      path: "application",
      name: "new-application",
      component: Pages.ApplicationWidgetContainer,
      props: () => ({
        page: APPLICATION_WIDGET_PAGE_E.APPLICATION
      })
    }, {
      path: "documents",
      name: "new-application-documents",
      component: Pages.ApplicationWidgetContainer,
      props: () => ({
        page: APPLICATION_WIDGET_PAGE_E.DOCUMENTS
      })
    }, {
      path: "submit",
      name: "new-application-submit",
      component: Pages.ApplicationWidgetContainer,
      props: () => ({
        page: APPLICATION_WIDGET_PAGE_E.SUBMIT
      })
    }]
  }]
}, {
  path: "/maintenance",
  name: "maintenance-message",
  component: Pages.GlobalMaintenanceContainer
}, {
  path: "/maintenance",
  name: "maintenance-message",
  component: Pages.GlobalMaintenanceContainer
}, {
  path: "/not-found",
  name: "not-found",
  component: Pages.NotFoundContainer
}, {
  path: "*",
  redirect: "/not-found"
}];
Vue.router = new VueRouter({
  routes,
  linkActiveClass: "sidetab-active"
});
let showNProgress = true;
Vue.router.beforeEach(async (to, from, next) => {
  /**
   * Load stylesheets
   */
  if (!getRouteMetaValue(to, "ignoreStyles")) await loadCustomStyles(to, from, next);

  /**
   * show top loader
   */
  if (getRouteMetaValue(to, "topProgress")) {
    setTimeout(() => {
      if (showNProgress) ProgressLoader.start();
      showNProgress = true;
    }, 50);
  }

  /**
   * Keep store updated with latest route
   */
  const {
    ignoreStateChange
  } = to.params;
  if (!ignoreStateChange) {
    store.commit("RouterStore/ROUTE_CHANGED", {
      to,
      from,
      isVueRoute: !!to.name
    });
  }

  /**
   * check for auth guards
   */
  if (getRouteMetaValue(to, "requiresAuth")) {
    authGuards(to, from, next);
  } else {
    next();
  }

  /**
   * Check if we should clear the state before we continue
   */
  if (getRouteMetaValue(to, "clearState")) {
    Vue.store.commit("clearState");
  }
});
Vue.router.afterEach(to => {
  document.title = to.name == "guest-lender" ? "Download Documents" : "Get Approved Today!";
  ProgressLoader.done();
  showNProgress = false;
  if (to.name) {
    defer(() => {
      $(".tooltip").tooltip("dispose");
    });
  }
});
export default Vue.router;